module.exports = __webpack_public_path__ + "static/media/bp.014ec691.png";